// extracted by mini-css-extract-plugin
export var horizontalList = "styles-module--horizontalList--1yVD2";
export var link = "styles-module--link--25BFY";
export var noMargin = "styles-module--noMargin--3r5Vi";